import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle, Home, ShoppingCart } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

export const PaymentCancelled = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <Card className="bg-zinc-900 border-zinc-800 max-w-md w-full">
        <CardContent className="pt-12 pb-12 text-center">
          <div className="w-20 h-20 bg-orange-400/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <XCircle className="w-12 h-12 text-orange-400" />
          </div>
          
          <h1 className="text-3xl font-black text-white mb-2">Payment Cancelled</h1>
          <p className="text-gray-400 mb-8">
            Your payment was cancelled. No charges were made to your account.
          </p>

          <div className="bg-zinc-800 rounded-lg p-4 mb-8 text-left">
            <p className="text-sm text-gray-300 mb-2">
              <strong className="text-white">Need help?</strong>
            </p>
            <ul className="text-xs text-gray-400 space-y-1">
              <li>• Having payment issues? Contact support</li>
              <li>• Questions about products? Check our FAQ</li>
              <li>• Want to try again? Return to shop</li>
            </ul>
          </div>

          <div className="grid sm:grid-cols-2 gap-4">
            <Button
              onClick={() => navigate('/')}
              variant="outline"
              className="border-zinc-700 text-white hover:bg-zinc-800"
            >
              <Home className="w-4 h-4 mr-2" />
              Go Home
            </Button>
            <Button
              onClick={() => navigate('/#products')}
              className="bg-amber-400 hover:bg-amber-500 text-black font-bold"
            >
              <ShoppingCart className="w-4 h-4 mr-2" />
              Return to Shop
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
